export function trackEvent(eventName, properties = {}) {
  if (typeof window !== 'undefined' && window.amplitude) {
    window.amplitude.track(eventName, properties);
  }
}

export function setAmplitudeUser(userId) {
  if (typeof window !== 'undefined' && window.amplitude && userId) {
    window.amplitude.setUserId(String(userId));
  }
}
